import { connect } from 'react-redux';
import StateToUrl from './state-to-url';

const mapStateToProps = state => ({
  selectedReport: state.reports.selectedReport,
  selectedLocation: state.reports.selectedLocation,
  dateRange: state.filter.dateRange,
  filterOptions: state.filter.filterOptions,
  comparisonDateRanges: state.filter.comparisonDateRanges,
  inApp: state.app.inApp,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(StateToUrl);
